import React, { Fragment, useState, useEffect } from 'react';
import LaunchIcon from '@material-ui/icons/Launch';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Col, Container, Row, Button } from 'reactstrap'
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt, faCheck } from "@fortawesome/free-solid-svg-icons";

import UpdateActivity from './UpdateActivity';


import AlertModal from '../../../../shared/components/Modal';



const ListActivitiesActions = ({ data, actividades }) => {
    const feasibility = data.data.original.feasibility;

    const [updateActivities, setUpdateActivities] = React.useState(false);
    const [showDeleteModal, setDeleteModal] = React.useState(false);

    const [successModal, setSuccessModal] = React.useState(false);
    const [errorModal, setErrorModal] = React.useState(false);
    const [agendedVisitError, setAgendedVisitError] = React.useState(false);


    const updateActivitiesModal = (e) => {
        setUpdateActivities(true);
    }

    const closeActivitiesModalUpdate = (e) => {
        setUpdateActivities(false);
    }

    useEffect(() => {
        //console.log(data.data.original.id_visita);
    }, []);

    const history = useHistory();

    const showActivityUpdate = () => {
        updateActivitiesModal();
    }

    const showModalDelete = () => {
        setDeleteModal(true);
    }

    const closeModalDelete = () => {
        setDeleteModal(false);
    }

    const finishDeleteModal = () => {
        let _url = "/clinical-studio/budget";
        if (window.location.pathname === process.env.PUBLIC_URL + '/clinical-studio/budget') {
            history.replace(process.env.PUBLIC_URL+"/");
            setTimeout(() => {
                history.replace({
                    pathname:process.env.PUBLIC_URL + _url,
                    state: feasibility
                });
            }, 0);
        } else {
            history.push({
                pathname: process.env.PUBLIC_URL +_url,
                state: feasibility
            });
        }
    }

    const deleteActivity = () => {
        let actividadJSON =
        {
            nombre: data.data.original.nombre,
            costo: data.data.original.costo,
            costo_patrocinador: data.data.original.costo_patrocinador,
            precio: data.data.original.precio,
            overhead_check: data.data.original.overhead_check,
            maneja_overhead: data.data.original.overhead_check == true ? "SI" : "NO",
            ok_presupuesto: parseFloat(data.data.original.precio) > parseFloat(data.data.original.costo_patrocinador) ? "SI" : "NO",
        }

        let submitJSON = {
            actividad: actividadJSON,
            position: data.data.original.position,
            id_visita: data.data.original.id_visita
        }

        try {
            fetch(`${process.env.REACT_APP_PUBLIC_URL}visitas/eliminar-actividad`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(submitJSON)
            }).then(response => response.json()).then(data => {
                closeModalDelete();
                setSuccessModal(true);
            }).catch(err => {
                console.log(err);
                closeModalDelete();
                setErrorModal(true);
            });
        }
        catch (e) {
            closeModalDelete();
            setErrorModal(true);
        }
    }

    return (<Fragment>
        <td role="cell">
            <IconButton style={{ fontSize: '15px' }} onClick={showActivityUpdate}>
                <FontAwesomeIcon icon={faEdit} />
            </IconButton>
            <IconButton style={{ fontSize: '15px' }} onClick={showModalDelete}>
                <FontAwesomeIcon icon={faTrashAlt} />
            </IconButton>
        </td>

        <UpdateActivity
            opened={updateActivities}
            updateActivitiesModal={updateActivitiesModal}
            closeActivitiesModal={closeActivitiesModalUpdate}
            actividad={data.data.original}
            actividades={actividades}
        />

        <AlertModal
            color="warning"
            title="Esta seguro de eliminar esta actividad?"
            modal={showDeleteModal}
            onOk={() => deleteActivity()}
            toggle={() => closeModalDelete()}
        />

        <AlertModal
            color="success"
            title="Actividad eliminada correctamente"
            modal={successModal}
            onOk={() => finishDeleteModal(false)}
            toggle={() => setSuccessModal(false)}
        />

        <AlertModal
            color="danger"
            title="Ha ocurrido un error al eliminar la actividad, es posible que la Visita ya halla sido agendada"
            modal={errorModal}
            onOk={() => setErrorModal(false)}
            toggle={() => setErrorModal(false)}
        />

        <AlertModal
            color="danger"
            title="No puede eliminar una actividad de una visita ya agendada"
            modal={agendedVisitError}
            onOk={() => {
                setAgendedVisitError(false);
                closeModalDelete();
            }}

            toggle={() => setAgendedVisitError(false)}
        />

    </Fragment>)
}

export default ListActivitiesActions;